import React from 'react';
import { withSSR } from 'react-i18next';
import { registerWidget } from '@okapi/core';
import { getGlobalRouter } from '@okapi/router-react';
import { WINDOWS_LANDING_NAME } from 'landings/windows';
import { State } from 'store/types';
import { unSanitizeLocalization } from 'utils/unsanitize-localiozation';
import '../../../../i18n.config';
import { WindowsRemote } from '../../common/widgets';
import { initWidgetDataWithShops } from '../init-widget-data-with-shops';

const WithI18 = withSSR()(WindowsRemote);

registerWidget<State, Record<string, string>>(`${__NAME__}/${WINDOWS_LANDING_NAME}`, state => {
  const router = getGlobalRouter();
  const store = initWidgetDataWithShops(state);
  const {
    localization: { initialI18nStore, initialLanguage },
  } = state;
  const updatedinItialI18nStore = unSanitizeLocalization(initialI18nStore);

  return remoteProps => (
    <WithI18
      initialI18nStore={updatedinItialI18nStore}
      initialLanguage={initialLanguage}
      router={router}
      store={store}
      {...remoteProps}
    />
  );
});
